import api from './api';

const d = (r) => r.data;

export const elAPI = {
  clauses: () => api.get('/api/el/clauses').then(d),
  addVersion: (key, body) => api.post(`/api/el/clauses/${key}/versions`, body).then(d),
  previewBlob: (key, template, version) => api.get(`/api/el/clauses/${key}/preview.pdf`, { params: { template, version }, responseType: 'blob' }).then(d),
  offshore: () => api.get('/api/el/offshore').then(d),
  saveOffshore: (body) => api.put('/api/el/offshore', body).then(d),
  aiProviders: () => api.get('/api/el/ai-providers').then(d),
  addAiProvider: (body) => api.post('/api/el/ai-providers', body).then(d),
  editAiProvider: (id, body) => api.put(`/api/el/ai-providers/${id}`, body).then(d),
  setStaffOffshore: (uid, body) => api.put(`/api/el/staff/${uid}/offshore`, body).then(d),
  existing: (params) => api.get('/api/el/existing', { params }).then(d),
  bulkPreview: (body) => api.post('/api/el/bulk/preview', body).then(d),
  bulkSend: (body) => api.post('/api/el/bulk/send', body).then(d),
  bulkStatus: (id) => api.get(`/api/el/bulk/${id}`).then(d),
  sendUpdated: (cid, body) => api.post(`/api/el/clients/${cid}/send-updated`, body).then(d),
  consents: (cid) => api.get(`/api/el/clients/${cid}/consents`).then(d),
  setRestriction: (cid, body) => api.put(`/api/el/clients/${cid}/offshore-restriction`, body).then(d),
  setReview: (cid, body) => api.put(`/api/el/clients/${cid}/clause-review`, body).then(d),
  setSignatory: (cid, body) => api.put(`/api/el/clients/${cid}/signatory`, body).then(d),
};

export const elErr = (e) => {
  const x = e?.response?.data?.detail;
  return typeof x === 'string' ? x : Array.isArray(x) ? x.map((i) => i.msg).join('; ') : 'Something went wrong';
};

export const STATUS_TONE = {
  'Not reviewed': 'bg-muted text-muted-foreground', 'Disclosure required': 'bg-amber-100 text-amber-900', 'Sent for signature': 'bg-sky-100 text-sky-900',
  Accepted: 'bg-emerald-100 text-emerald-800', Declined: 'bg-rose-100 text-rose-800', 'Further review required': 'bg-orange-100 text-orange-900',
};
